<div class="form-control" [formGroup]="form" [class.invalid]="isInvalid()">
	<label for="control" [for]="form_control_id" class="label">{{ label }}{{ getRequired() }} {{ getError() }}</label>
	<input
		id="input"
		type="hidden"
		[id]="form_control_id"
		[attr.name]="form_control_name"
		[formControlName]="form_control_name"
	/>
	<div class="slider" [ngClass]="slide_direction">
		<a class="slide slider-nav-button" [class.inactive]="dates[0] === min_date" (click)="previous()">
			<i class="fa fa-chevron-left"></i>
		</a>
		<div class="slide date-list" #dateList>
			<a *ngFor="let date of dates"
			   [class.selected]="date === form_control.value"
			   [class.unavailable]="(unavailable_dates && unavailable_dates.includes(date)) || (unavailable_days && unavailable_days.includes(date|date:'EEEE'|lowercase))"
			   (click)="onSelectDate(date)"
			>
				<p class="day-of-week">{{ date | date: 'EEE' }}</p>
				<p class="day-of-month">{{ date | date: 'dd' }}</p>
				<p class="month">{{ date | date: 'LLL' }}</p>
			</a>
		</div>
		<a class="slide slider-nav-button" (click)="next()">
			<i class="fa fa-chevron-right"></i>
		</a>
	</div>
	<span *ngIf="info !== null" class="info" [class.highlighted]="highlighted_info">
		{{ info }}
	</span>
</div>
